import { useEffect, useRef, useState } from 'react';

const CYCLE_MS = 48 * 60 * 60 * 1000;
const TARGET_MS = 30 * 24 * 60 * 60 * 1000;

function pad(n) {
  return String(n).padStart(2, '0');
}

function currentTarget() {
  const now = Date.now();
  const cycleStart = Math.floor(now / CYCLE_MS) * CYCLE_MS;
  return cycleStart + TARGET_MS;
}

export default function Countdown() {
  const [time, setTime] = useState(() => ({ d: '30', h: '00', m: '00', s: '00' }));
  const [tickKey, setTickKey] = useState({ d: 0, h: 0, m: 0, s: 0 });
  const targetRef = useRef(currentTarget());
  const lastRef = useRef({ d: '', h: '', m: '', s: '' });

  useEffect(() => {
    function update() {
      let diff = targetRef.current - Date.now();
      if (diff <= 0) {
        targetRef.current = currentTarget();
        diff = targetRef.current - Date.now();
      }
      const next = {
        d: pad(Math.floor(diff / 86400000)),
        h: pad(Math.floor((diff % 86400000) / 3600000)),
        m: pad(Math.floor((diff % 3600000) / 60000)),
        s: pad(Math.floor((diff % 60000) / 1000)),
      };
      const ticked = { ...tickKey };
      let changed = false;
      ['d', 'h', 'm', 's'].forEach((k) => {
        if (next[k] !== lastRef.current[k]) {
          ticked[k] += 1;
          lastRef.current[k] = next[k];
          changed = true;
        }
      });
      if (changed) {
        setTime(next);
        setTickKey(ticked);
      }
    }
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="countdown" id="countdown">
      <Box num={time.d} label="Días" tickKey={tickKey.d} animate />
      <span className="count-sep">:</span>
      <Box num={time.h} label="Horas" tickKey={tickKey.h} animate />
      <span className="count-sep">:</span>
      <Box num={time.m} label="Min" tickKey={tickKey.m} animate />
      <span className="count-sep">:</span>
      <Box num={time.s} label="Seg" tickKey={tickKey.s} animate />
    </div>
  );
}

function Box({ num, label, tickKey, animate }) {
  return (
    <div className="count-box">
      <div key={animate ? tickKey : 'static'} className={`count-num${animate ? ' tick' : ''}`}>
        {num}
      </div>
      <div className="count-label">{label}</div>
    </div>
  );
}
